import { SetStateAction, useEffect } from 'react'
import styled from 'styled-components'
import { breakpoints } from '../assets/styles/mediaBreakpoints'
// import { NavLink } from 'react-router-dom'
import quizData from '../assets/data/quiz_phase2.json'
import BackAndNext from '../components/common/composite/backAndNext'
import { useBool } from '../hooks/bool'
import { WhiteBox } from '../assets/styled_components/boxStyle'

const QuizPBasket = ({
  pBasket,
  setPBasket,
}: {
  pBasket: string[]
  setPBasket: React.Dispatch<SetStateAction<string[]>>
}) => {
  const isNextDisabled = useBool(true)
  useEffect(() => {
    isNextDisabled.set(pBasket.length === 0 ? true : false)
  }, [pBasket])
  return (
    <QuizSection>
      <QuizContentContainer>
        <QuizTitleContainer>
          <h4>
            If you could shape your ideal world, what would be your top
            priority?
          </h4>
          <p>Choose your passion! You can choose more than one.</p>
        </QuizTitleContainer>
        {/* TODO Uncomment this link when quiz phase 1 is finished */}
        {/* <NotSureButton to="/quiz-v1">
          I’m not sure, what my top priority?
        </NotSureButton> */}
      </QuizContentContainer>
      <PCardContainer>
        {quizData.map((p, index) => (
          <PCard
            key={index}
            title={p.basket}
            subTitle={p.subtitle}
            pBasket={pBasket}
            setP={setPBasket}
          />
        ))}
      </PCardContainer>
      <BackAndNext linkNext="/quiz-v2" isDisabled={isNextDisabled.val} />
    </QuizSection>
  )
}
const PCard = ({
  title,
  subTitle,
  pBasket,
  setP,
}: {
  title: string
  subTitle: string
  pBasket: string[]
  setP: React.Dispatch<SetStateAction<string[]>>
}) => {
  const onCardClick = (
    basket: string[],
    setBasket: React.Dispatch<SetStateAction<string[]>>,
    title: string,
  ) => {
    if (basket.includes(title)) {
      setBasket(basket.filter((obj) => obj !== title))
    } else {
      setBasket([...basket, title])
    }
    return
  }
  return (
    <PCardStyle
      $arr={pBasket}
      $item={title}
      onClick={() => onCardClick(pBasket, setP, title)}
    >
      <h4>{title}</h4>
      <p>{subTitle}</p>
    </PCardStyle>
  )
}

const QuizSection = styled.div`
  width: 100%;
  background: radial-gradient(
    ellipse at center 25%,
    ${(props) => props.theme.colors['primary-100']} 0%,
    ${(props) => props.theme.colors['primary-500']} 34%,
    ${(props) => props.theme.colors['primary-100']} 95%
  );
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  padding: 120px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  @media (max-width: ${breakpoints.mobile}px) {
    padding: 64px 24px;
  }
`
const QuizTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`
const QuizContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 640px;
  gap: 24px;
  text-align: center;
  @media (max-width: ${breakpoints.mobile}px) {
    max-width: 100%;
  }
`
// TODO Uncomment when the quiz phase 1 is ready
// const NotSureButton = styled(NavLink)`
//   font-size: 16px;
//   font-weight: bold;
//   transition: text-decoration 0.5s;
//   color: black;
//   &:hover {
//     text-decoration: underline;
//   }
// `
const PCardStyle = styled(WhiteBox)`
  padding: 16px 16px 30px 16px;
  align-items: flex-start;
  width: 240px;
  gap: 10px;
`
const PCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;

  & > div {
    flex: 0 1 auto;
  }

  @media (max-width: ${breakpoints.mobile}px) {
    & > div {
      flex: 0 1 calc(50% - 12px);
    }
  }
`

export default QuizPBasket
